// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldFlash = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 21 21',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.30738 11.5338H10.8051V17.3538C10.8051 18.2106 11.8721 18.6148 12.438 17.9681L18.557 11.0164C19.0905 10.4102 18.6621 9.46444 17.8538 9.46444H15.356V3.64444C15.356 2.78761 14.289 2.38344 13.7232 3.03011L7.60413 9.98178C7.07871 10.588 7.50713 11.5338 8.30738 11.5338Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.83711 17.5724H1.98711C1.65569 17.5724 1.38086 17.2975 1.38086 16.9661C1.38086 16.6347 1.65569 16.3599 1.98711 16.3599H6.83711C7.16853 16.3599 7.44336 16.6347 7.44336 16.9661C7.44336 17.2975 7.16853 17.5724 6.83711 17.5724Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.41211 11.1056H1.98711C1.65569 11.1056 1.38086 10.8307 1.38086 10.4993C1.38086 10.1679 1.65569 9.89307 1.98711 9.89307H4.41211C4.74353 9.89307 5.01836 10.1679 5.01836 10.4993C5.01836 10.8307 4.74353 11.1056 4.41211 11.1056Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldFlash };
